module.exports = __webpack_public_path__ + "static/media/login.d2898952.jpeg";